<template>
	<div class="offline">
		<!-- 顶部导航 -->
		<div class="nav" style="border: none;">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>线下订单</span>
			<div></div>
		</div>
		<!-- 表单 -->
		<div class="cotent">
			<div class="backgd"></div>
			<!-- 填写内容 -->
			<div class="main">
				<van-panel class="container">
					<div slot="header">
						<van-cell class="container__value">
							<div slot="default">
								<van-radio-group @change="stateChange" class="container_title" v-model="radio1" checked-color="#f1452f"
								 icon-size="1rem">
									<van-radio name="1">俱百家直供</van-radio>
									<van-radio name="2">体验店供货</van-radio>
									<van-radio name="3">其它供货</van-radio>
								</van-radio-group>
							</div>
						</van-cell>
					</div>
					<div>
						<van-radio-group class="container_select" v-model="radio2" checked-color="#f1452f" icon-size="0.8rem">
							<div class="container_select_title">订单方式:</div>
							<div class="list list_1" v-if="type1" v-for="item in typeList">
								<van-radio :name="item.title">{{item.title}}</van-radio>
							</div>
							<div class="list list_1" v-if="type2">
								<van-radio name="直接购买">直接购买</van-radio>
							</div>
						</van-radio-group>
						<van-cell-group class="uplod">
							<div class="uplod-title">请上传您的合同</div>
							<van-uploader :after-read="subCamera1" v-model="fileList1" multiple :max-count="4" />
							<div class="uplod-title">请上传您的单据</div>
							<van-uploader :after-read="subCamera" v-model="fileList" multiple :max-count="4" />
							<div class="uplod-title">请上您的传图纸</div>
							<van-uploader :after-read="subCamera2" v-model="fileList2" multiple :max-count="4" />
							<van-field rows="2" autosize type="textarea" v-model="order_message" placeholder="请填写备注信息~" show-word-limit />
						</van-cell-group>
						<van-field class="ads">
							<div slot="label">订单来源:</div>
							<van-cell slot="input" :title="city" is-link @click="select=true" />
						</van-field>
						<van-field class="ads" v-model="adsDetail" label="付款码:" placeholder="请输入商户会员编号" />
						<van-field class="money" v-model="money" label="支付金额:" type="number" placeholder="请输入金额(不能小于1元)" />
					</div>
				</van-panel>
				<!-- 底部联系人 -->
				<div class="footer">
					<van-field label="联系人" placeholder="请输入姓名" v-model="name" />
					<van-field label="联系电话" type="tel" placeholder="请输入手机号" v-model="tel" />
					<van-field label="收货地址" placeholder="请输入地址" v-model="address" />
					<van-radio-group class="container_footer" v-model="radio3" checked-color="#f1452f" icon-size="0.9rem">
						<van-radio class="footer_radio" name="0">无需开票</van-radio>
						<van-radio class="footer_radio" name="1">开票信息</van-radio>
					</van-radio-group>
				</div>
				<div class="tel">如有疑问可联系当地线下服务商400-8722-000</div>
			</div>
			<!-- 城市选择 -->
			<van-popup v-model="select" position="bottom" :style="{ 'max-height': '80%' }">
				<van-area :area-list="areaList" @confirm="areaOk" @cancel="select=false" />
			</van-popup>
		</div>
		<van-goods-action>
			<van-goods-action-icon icon="wap-home-o" text="首页" to="/home" />
			<van-goods-action-icon icon="phone-o" text="客服" @click="open53()" />
			<van-goods-action-button type="warning" text="对公转账" @click="duig=true" />
			<van-goods-action-button type="danger" text="立即支付" @click="show=true" />
		</van-goods-action>
		<!-- 选择支付方式 -->
		<van-popup v-model="show" position="bottom">
			<van-panel class="payment">
				<div slot="header" class="payment_header">
					支付方式
				</div>
				<div class="payment_content">
					<van-radio-group v-model="radio">
						<van-cell-group>
							<van-cell title="微信支付" clickable @click="radio='1'">
								<div slot="icon" class="payment_icon">
									<img src="../../../assets/wx.png" alt="">
								</div>
								<van-radio checked-color="#F1452F" icon-size="1rem" slot="right-icon" name="1" />
							</van-cell>
							<van-cell title="支付宝支付" clickable @click="radio='2'">
								<div slot="icon" class="payment_icon">
									<img src="../../../assets/zfb.png" alt="">
								</div>
								<van-radio checked-color="#F1452F" icon-size="1rem" slot="right-icon" name="2" />
							</van-cell>
<!-- 							<van-cell title="银行卡支付" clickable @click="radio='3'">
								<div slot="icon" class="payment_icon">
									<img src="../../../assets/yl.png" alt="">
								</div>
								<van-radio checked-color="#F1452F" icon-size="1rem" disabled slot="right-icon" name="3" />
							</van-cell> -->
						</van-cell-group>
					</van-radio-group>
					<div class="pays_btn">
						<button @click="submitPay">确定</button>
					</div>
				</div>
			</van-panel>
		</van-popup>
		<!-- 对公转账 -->
		<van-popup v-model="duig" class="duig" position="bottom">
			<div class="duig-top">对公账户</div>
			<van-cell size="large">
				<div slot="title" class="duig-title">
					<div>开户名称：</div>
					<div>广州俱百家网络科技有限公司</div>
				</div>
			</van-cell>
			<van-cell size="large">
				<div slot="title" class="duig-title">
					<div>开户账户：</div>
					<div>3602073809100114062</div>
				</div>
			</van-cell>
			<van-cell size="large">
				<div slot="title" class="duig-title">
					<div>开户银行：</div>
					<div>中国工商银行广州泰沙路支行</div>
				</div>
			</van-cell>
			<div class="duig-foot">如果您付款成功，请在<span>会员中心</span>-<span>线下订单</span>-<span>订单详情</span>中上传您的支付凭证，我们会第一时间核实并发货。若有问题请联系客服
				400-8722-000</div>
			<div class="duig-btn">
				<van-button round size="small" @click="sateway" style=" width: 45%; border: 1px solid #eee;">取消</van-button>
				<van-button round color="#f1452f" size="small" @click="duigs" style=" width: 45%; border: 1px solid #f1452f;">提交订单</van-button>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import areaList from "@/assets/js/area.js"

	export default {
		data() {
			return {
				areaList,
				radio: '1',
				radio1: '1',
				radio2: '不限时使用免押金',
				radio3: '0',
				value: '',
				money: '',
				name: '',
				tel: '',
				address: '',
				adsDetail: '',
				city: '选择城市',
				order_message: '',
				fileList: [],
				fileList1: [],
				fileList2: [],
				fileList3: [],
				typeList: {},
				select: false,
				type1: true,
				type2: false,
				show: false,
				duig: false,
				annex: [], //附件列表,
				annex1: [], //附件列表,
				annex2: [], //附件列表,
			}
		},
		created() {
			this.getData();
		},
		methods: {
			//上传附件
			subCamera(file) {
				var that = this;
				let content = file.file;
				let data = new FormData();
				data.append('file', content);
				that.$axios.post(baseUrl + '/mobile/Index/imgUpload', data, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function(res) {
					if (res.data.code == 11) {
						that.$toast(res.data.msg);
						that.annex.push(res.data.data);
						console.log(that.annex)
					}
				}).catch(function(err) {
					console.log(err);
				})
			},
			subCamera1(file) {
				var that = this;
				let content = file.file;
				let data = new FormData();
				data.append('file', content);
				that.$axios.post(baseUrl + '/mobile/Index/imgUpload', data, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function(res) {
					if (res.data.code == 11) {
						that.$toast(res.data.msg);
						that.annex1.push(res.data.data);
						console.log(that.annex)
					}
				}).catch(function(err) {
					console.log(err);
				})
			},
			subCamera2(file) {
				var that = this;
				let content = file.file;
				let data = new FormData();
				data.append('file', content);
				that.$axios.post(baseUrl + '/mobile/Index/imgUpload', data, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function(res) {
					if (res.data.code == 11) {
						that.$toast(res.data.msg);
						that.annex2.push(res.data.data);
						console.log(that.annex)
					}
				}).catch(function(err) {
					console.log(err);
				})
			},
			//53客服
			_open53() {
				let _53 = $53.createApi();
				_53.push('cmd', 'mtalk');
				_53.query();
			},
			sumt() {
				console.log(this.fileList);
			},
			//验证
			isNone() {
				if (this.fileList.length == 0) {
					this.$toast('请上传单据');
					return false;
				};
				if (this.fileList1.length == 0) {
					this.$toast('请上传合同');
					return false;
				};
				if (this.fileList2.length == 0) {
					this.$toast('请上传图纸');
					return false;
				};
				if (this.city == '选择城市') {
					this.$toast('请选择订单来源');
					return false;
				};
				if (this.adsDetail == '') {
					this.$toast('会员编号不能为空');
					return false;
				};
				if (this.money == '') {
					this.$toast('请输入金额');
					return false;
				};
				if (this.name == '') {
					this.$toast('请输入姓名');
					return false;
				};
				if (this.tel == '') {
					this.$toast('请输入手机号');
					return false;
				};
				if (this.address == '') {
					this.$toast('请输入详细地址');
					return false;
				};
				return true;
			},
			//点击按钮
			submitPay() {
				if (this.isNone()) {
					const toast = this.$toast.loading({
						duration: 0,
						forbidClick: true,
						message: '提交中',
						loadingType: 'spinner'
					});
					let formData = new FormData();
					for (let key in this.fileList) {
						formData.append('file[]', this.fileList[key].file);
					}
					let wx = (() => {
						return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
					})();
					if (wx) {
						alert("请在微信以外的浏览器打开进行支付");
						return false;
					} else {
						let data = {};
						data.supplies_mode = this.radio1;
						data.order_mode = this.radio2;
						data.order_message = this.order_message;
						data.image = this.annex;
						data.contract_image = this.annex1;
						data.draw_image = this.annex2;
						data.payment_user = this.adsDetail;
						data.total = this.money;
						data.real_name = this.name;
						data.phone = this.tel;
						data.source = this.city;
						data.address = this.address;
						data.token = localStorage.getItem('Authorization');
						if (this.radio == '1') {
							this.$axios.post(baseUrl + '/mobile/OfflineOrder/offlineOrderAdd', data).then((res) => {
								if (res.data.code == 19) {
									this.$toast.clear();
									window.location.href = baseUrl + '/mobile/Pay/offlineWapWxPay?out_trade_no=' + res.data.data
									this.$router.push({
										path: '/OffList',
									})
								} else {
									this.$toast.clear();
									this.$toast(res.data.msg);
								}
							}).catch((err) => {
								console.log(err);
							});
						} else if (this.radio == '2') {
							this.$axios.post(baseUrl + '/mobile/OfflineOrder/offlineOrderAdd', data).then((res) => {
								if (res.data.code == 19) {
									this.$toast.clear();
									window.location.href = baseUrl + '/mobile/Pay/offlineWapPay?out_trade_no=' + res.data.data
									this.$router.push({
										path: '/OffList',
									})
								} else {
									this.$toast.clear();
									this.$toast(res.data.msg);
								}
							}).catch((err) => {
								console.log(err);
							});
						} else {
							this.$toast('暂不支持');
						}
					}
				}
			},
			// 取消对公转账
			sateway() {
				this.duig = false;
				this.show = false;
			},
			//对公转账
			duigs() {
				if (this.isNone()) {
					const toast = this.$toast.loading({
						duration: 0,
						forbidClick: true,
						message: '提交中',
						loadingType: 'spinner'
					});
					let formData = new FormData();
					for (let key in this.fileList) {
						formData.append('file[]', this.fileList[key].file);
					}
					let data = {};
					data.supplies_mode = this.radio1;
					data.order_mode = this.radio2;
					data.order_message = this.order_message;
					data.image = this.annex;
					data.contract_image = this.annex1;
					data.draw_image = this.annex2;
					data.payment_user = this.adsDetail;
					data.total = this.money;
					data.real_name = this.name;
					data.phone = this.tel;
					data.source = this.city;
					data.address = this.address;
					data.token = localStorage.getItem('Authorization');
					data.gateway = 1;
					this.$axios.post(baseUrl + '/mobile/OfflineOrder/offlineOrderAdd', data).then((res) => {
						if (res.data.code == 19) {
							this.$toast.clear();
							this.$toast('提交成功');
							this.duig = false;
							this.$router.push({
								path: '/OffList',
							})
						} else {
							this.$toast.clear();
							this.$toast(res.data.msg);
							this.duig = false;
						}
					}).catch((err) => {
						console.log(err);
					});
				}
			},
			//租赁方式
			getData() {
				this.$axios.post(baseUrl + '/mobile/Base/lease_title').then((res) => {
					if (res.data.code == 2) {
						this.typeList = res.data.data;
					}
				}).catch(function(err) {
					console.log(err);
				});
			},
			//选择方式
			stateChange(name) {
				if (name === '1') {
					this.type1 = true;
					this.type2 = false;
					this.radio2 = '不限时使用免押金'
				} else {
					this.type1 = false;
					this.type2 = true;
					this.radio2 = '直接购买'
				}
			},
			//选中地址
			areaOk(event) {
				this.city = '';
				for (var item in event) {
					this.city += event[item].name;
				}
				this.select = false;
			}
		},
		watch: {
			money: function(msg) {
				if (msg < 1) {
					this.money = ''
				}
			}
		}
	}
</script>

<style scoped>
	@import "offline.css";

	.duig-foot span {
		color: #F1452F;
	}
</style>



// WEBPACK FOOTER //
// src/components/min/OfflineList/offline.vue